(function () {
  "use strict";

  var drawer = document.querySelector("[data-cart-drawer]");
  var overlay = document.querySelector("[data-cart-overlay]");
  var closeBtn = document.querySelector("[data-cart-close]");
  var toggleBtns = document.querySelectorAll("[data-cart-toggle]");
  var body = document.querySelector("[data-cart-body]");
  var emptyEl = document.querySelector("[data-cart-empty]");
  var footerEl = document.querySelector("[data-cart-footer]");
  var subtotalEl = document.querySelector("[data-cart-subtotal]");
  var countEls = document.querySelectorAll("[data-cart-count]");
  var shippingBar = document.querySelector("[data-free-shipping-bar]");
  var shippingBarText = shippingBar ? shippingBar.querySelector("[data-free-shipping-text]") : null;
  var shippingBarFill = shippingBar ? shippingBar.querySelector("[data-free-shipping-fill]") : null;

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  /* Three rungs, not two.

     Shopify measures the free-shipping threshold against the subtotal AFTER
     a discount code is applied, but this bar only ever sees the pre-discount
     cart -- codes are entered at checkout. So "$150 reached" and "free
     shipping is actually safe" are two different numbers.

     With a p% code, a cart only keeps free shipping at threshold / (1 - p).
     At $150 and 15% that's $176.47. Between $150.00 and $176.46 the bar is
     telling the truth about today and lying about checkout.

     Rather than bury that in a footnote, the middle rung names the exact
     amount that makes it safe -- which is also the moment the shopper is
     most willing to add it. Above the safe line the caveat disappears
     entirely, because it no longer applies and repeating it would just
     erode a real win. Set the code percent to 0 to collapse back to two
     rungs. */
  function updateFreeShippingBar(cartTotal, alreadyDiscounted, discountedRate) {
    if (!shippingBar || !shippingBarText || !shippingBarFill) return;
    if (!isFinite(discountedRate) || discountedRate < 0) discountedRate = 0;
    var threshold = parseInt(shippingBar.getAttribute("data-threshold-cents"), 10) || 15000;
    var progressText = shippingBar.getAttribute("data-progress-text") || "You're {{ amount }} away from free shipping!";
    var successText = shippingBar.getAttribute("data-success-text") || "You've unlocked free shipping!";
    var atRiskText = shippingBar.getAttribute("data-atrisk-text") || "";
    var codePercent = parseFloat(shippingBar.getAttribute("data-code-percent"));
    if (!isFinite(codePercent) || codePercent < 0 || codePercent >= 100) codePercent = 0;

    /* If a code is ALREADY on the cart, cart.total_price is already the
       post-discount figure -- which is the number Shopify will judge at
       checkout. There is nothing left to warn about, so the at-risk rung
       must not fire.

       This is not hypothetical: any /discount/LVLUP link (an email campaign,
       a promo landing) applies the code to the cart on arrival. Those
       shoppers would otherwise be told to add another $27 they don't need,
       to protect a discount they've already banked. Caught in live testing,
       where the drawer read "$48.00 away" on a $120 cart because the cart
       total was really $102. */
    if (alreadyDiscounted) codePercent = 0;

    var pct = Math.min(100, Math.round((cartTotal / threshold) * 100));
    shippingBarFill.style.width = pct + "%";

    if (cartTotal < threshold) {
      /* Ask for PRODUCT, not for total.

         With a code on the cart, every dollar of product only lifts the
         total by (1 - rate) dollars. A $102 total against a $150 threshold
         is "$48 away" in total terms, but adding $48 of product lands at
         $142.80 -- still short, and the shopper has been told otherwise.
         They actually need $56.47 of product.

         Gross the gap back up by the cart's own effective rate (taken from
         the cart, not from the LVLUP setting, so it stays right for any
         code or stacked codes). Without a discount the rate is 0 and this
         is a no-op. */
      var gapToThreshold = threshold - cartTotal;
      var rate = 0;
      if (discountedRate > 0 && discountedRate < 1) rate = discountedRate;
      var productNeeded = rate > 0 ? Math.ceil(gapToThreshold / (1 - rate)) : gapToThreshold;
      var remaining = money(productNeeded);
      shippingBarText.textContent = progressText.replace("{{ amount }}", remaining).replace("{{amount}}", remaining);
      shippingBar.classList.remove("is-at-risk");
      return;
    }

    /* The naive threshold / (1 - p) is a cent too conservative, because
       Shopify rounds the discount to whole cents before subtracting. At
       $176.47 the raw maths says $149.9995 (short), but Shopify computes
       round(17647 * 0.15) = 2647, leaving exactly $150.00 -- safe. Solve for
       the real boundary: the smallest cart where cart - round(cart * p)
       still clears the threshold. Start from the naive value and walk down
       while the condition holds. */
    var safeThreshold = threshold;
    if (codePercent > 0) {
      var p = codePercent / 100;
      var candidate = Math.ceil(threshold / (1 - p));
      while (candidate > threshold && candidate - 1 - Math.round((candidate - 1) * p) >= threshold) {
        candidate -= 1;
      }
      safeThreshold = candidate;
    }

    if (codePercent > 0 && atRiskText && cartTotal < safeThreshold) {
      /* Ask for a round, spendable number -- never "add $0.02".

         An earlier version solved this with a floor that flipped the bar to
         "unlocked" whenever the gap was small. That was the wrong lever: it
         bought tidy copy by telling the shopper they were safe when checkout
         would disagree, and widening the floor widens that lie. A $5 floor
         plus a future $5 product is precisely the cart that would hit it.

         Instead the STATE stays truthful -- at risk is at risk, to the cent
         -- and only the number shown is rounded UP to something you could
         actually spend. Rounding up is the safe direction: adding the amount
         we name always clears the gap, and usually clears it with room. */
      var gap = safeThreshold - cartTotal;
      var minAsk = parseInt(shippingBar.getAttribute("data-min-topup-cents"), 10);
      if (!isFinite(minAsk) || minAsk < 0) minAsk = 500;
      var ask = Math.max(gap, minAsk);
      ask = Math.ceil(ask / 100) * 100; // whole dollars
      var toSafe = money(ask);
      shippingBarText.textContent = atRiskText.replace("{{ amount }}", toSafe).replace("{{amount}}", toSafe);
      shippingBar.classList.add("is-at-risk");
      renderGapClosers(gap);
      return;
    }

    shippingBarText.textContent = successText;
    shippingBar.classList.remove("is-at-risk");
    renderGapClosers(0);
  }

  /* Turn "add $17.00" into something clickable, sized to the actual gap.

     Ranking, in order: anything that closes the gap on its own wins, and
     among those the CHEAPEST wins -- suggesting the priciest item that
     clears it would be an upsell wearing a helper's coat. Only if nothing
     closes it alone do we fall back to the largest items, which at least
     move the shopper closest.

     Deliberately does nothing when the gap is zero or the feature is off,
     and the container starts hidden so an empty collection renders nothing
     rather than an empty heading. */
  function renderGapClosers(gapCents) {
    var box = document.querySelector("[data-gap-closers]");
    if (!box) return;
    var list = box.querySelector("[data-gap-list]");
    var dataEl = box.querySelector("[data-gap-candidates]");
    if (!list || !dataEl) return;

    if (!gapCents || gapCents <= 0) {
      box.hidden = true;
      list.innerHTML = "";
      return;
    }

    var candidates;
    try { candidates = JSON.parse(dataEl.textContent) || []; } catch (e) { candidates = []; }
    if (!candidates.length) { box.hidden = true; return; }

    var count = parseInt(box.getAttribute("data-gap-count"), 10) || 2;
    var closers = candidates.filter(function (c) { return c.price >= gapCents; })
                            .sort(function (a, b) { return a.price - b.price; });
    var picks = closers.length
      ? closers.slice(0, count)
      : candidates.slice().sort(function (a, b) { return b.price - a.price; }).slice(0, count);

    if (!picks.length) { box.hidden = true; return; }

    list.innerHTML = "";
    picks.forEach(function (p) {
      var row = document.createElement("button");
      row.type = "button";
      row.className = "cart-drawer__gap-item";
      row.setAttribute("data-gap-add", p.id);
      row.innerHTML =
        (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<span class="cart-drawer__gap-thumb"></span>') +
        '<span class="cart-drawer__gap-name"></span>' +
        '<span class="cart-drawer__gap-price"></span>';
      // textContent, not innerHTML -- product titles are merchant-authored
      // and must never be able to inject markup into the drawer.
      row.querySelector(".cart-drawer__gap-name").textContent = p.title;
      row.querySelector(".cart-drawer__gap-price").textContent = money(p.price);
      list.appendChild(row);
    });
    box.hidden = false;
  }

  function updateCartCount(count) {
    countEls.forEach(function (el) {
      el.textContent = count;
      if (count === 0) {
        el.setAttribute("data-zero", "");
      } else {
        el.removeAttribute("data-zero");
      }
    });
  }

  /* Show the arithmetic when a code is on the cart.

     Line items render at their undiscounted unit price; the subtotal
     renders discounted. With nothing between them, three $40 tees sat above
     a $102 subtotal and the missing $18 was simply unexplained. Shown in
     full, the column reads: items $120.00, LVLUP -$18.00, subtotal $102.00.

     Hidden entirely when there's no discount -- an "Items" row that always
     equals the subtotal is just clutter. */
  function renderCartDiscounts(cart) {
    var box = document.querySelector("[data-cart-discounts]");
    if (!box) return;
    var rows = box.querySelector("[data-cart-discount-rows]");
    var itemsEl = box.querySelector("[data-cart-items-total]");
    var apps = cart.cart_level_discount_applications || [];

    if (!apps.length || !(cart.total_discount > 0)) {
      box.hidden = true;
      if (rows) rows.innerHTML = "";
      return;
    }

    if (itemsEl) {
      itemsEl.textContent = money(
        typeof cart.items_subtotal_price === "number" ? cart.items_subtotal_price : cart.original_total_price || 0
      );
    }
    if (rows) {
      rows.innerHTML = "";
      apps.forEach(function (a) {
        var row = document.createElement("div");
        row.className = "cart-drawer__line cart-drawer__line--discount";
        var name = document.createElement("span");
        /* Label the row, don't just name the code. "LVLUP" alone is a
           string the shopper has to recognise; "LVLUP Discount" says what
           the line IS. Guarded so a code already containing the word can't
           produce "Holiday Discount Discount". Codes are merchant-authored;
           never inject them as markup. */
        var code = a.title || "";
        name.textContent = !code
          ? "Discount"
          : /discount/i.test(code)
            ? code
            : code + " Discount";
        var amt = document.createElement("span");
        amt.textContent = "-" + money(a.total_allocated_amount || 0);
        row.appendChild(name);
        row.appendChild(amt);
        rows.appendChild(row);
      });
    }
    box.hidden = false;
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);
    /* total_discount > 0 means a code is already on the cart, so total_price
       is post-discount: no at-risk warning is needed, and the "add X more"
       figure has to be grossed up so it asks for PRODUCT rather than total.
       The rate is derived from the cart itself rather than the LVLUP
       setting, so it stays correct for any code, or several stacked. */
    var itemsTotal = typeof cart.items_subtotal_price === "number"
      ? cart.items_subtotal_price
      : cart.original_total_price || 0;
    var appliedRate = itemsTotal > 0 ? (cart.total_discount || 0) / itemsTotal : 0;
    updateFreeShippingBar(cart.total_price || 0, (cart.total_discount || 0) > 0, appliedRate);

    if (!body) return;

    if (cart.item_count === 0) {
      if (emptyEl) emptyEl.style.display = "";
      if (footerEl) footerEl.style.display = "none";
      var existingItems = body.querySelectorAll(".cart-drawer__item");
      existingItems.forEach(function (n) { n.remove(); });
      return;
    }

    if (emptyEl) emptyEl.style.display = "none";
    if (footerEl) footerEl.style.display = "";
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    renderCartDiscounts(cart);

    var existingItems = body.querySelectorAll(".cart-drawer__item");
    existingItems.forEach(function (n) { n.remove(); });

    cart.items.forEach(function (item) {
      var el = document.createElement("div");
      el.className = "cart-drawer__item";
      var optionsHtml = "";
      if (item.options_with_values && item.options_with_values.length) {
        var hasRealOptions = item.options_with_values.some(function (o) {
          return o.name.toLowerCase() !== "title";
        });
        if (hasRealOptions) {
          optionsHtml =
            '<p class="cart-drawer__item-options">' +
            item.options_with_values.map(function (o) { return o.value; }).join(" · ") +
            "</p>";
        }
      }
      el.innerHTML =
        (item.image ? '<img src="' + item.image + '&width=160" alt="' + (item.product_title || "") + '">' : '<div style="width:80px;height:96px;background:var(--clr-panel)"></div>') +
        '<div class="cart-drawer__item-body" style="flex:1;min-width:0;">' +
        '<h4 class="cart-drawer__item-title">' + item.product_title + "</h4>" +
        optionsHtml +
        '<p class="cart-drawer__item-price">' + money(item.final_line_price) + "</p>" +
        '<div class="cart-drawer__item-controls">' +
        '<div class="cart-drawer__qty">' +
        '<button type="button" data-decrease="' + item.key + '" aria-label="Decrease">−</button>' +
        '<span style="width:32px;text-align:center;display:inline-block;">' + item.quantity + "</span>" +
        '<button type="button" data-increase="' + item.key + '" aria-label="Increase">+</button>' +
        "</div>" +
        '<button type="button" class="cart-drawer__remove" data-remove="' + item.key + '" aria-label="Remove">Remove</button>' +
        "</div></div>";
      body.appendChild(el);
    });
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function changeLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    fetchCart();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  toggleBtns.forEach(function (btn) {
    btn.addEventListener("click", openDrawer);
  });
  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
  if (overlay) overlay.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  if (body) {
    body.addEventListener("click", function (e) {
      var dec = e.target.closest("[data-decrease]");
      var inc = e.target.closest("[data-increase]");
      var rem = e.target.closest("[data-remove]");
      if (dec) {
        var key = dec.getAttribute("data-decrease");
        var span = dec.parentElement.querySelector("span");
        var qty = Math.max(0, parseInt(span.textContent, 10) - 1);
        changeLine(key, qty);
      } else if (inc) {
        var key2 = inc.getAttribute("data-increase");
        var span2 = inc.parentElement.querySelector("span");
        var qty2 = parseInt(span2.textContent, 10) + 1;
        changeLine(key2, qty2);
      } else if (rem) {
        changeLine(rem.getAttribute("data-remove"), 0);
      }
    });
  }

  /* ---- Product form: variant selection + Ajax add to cart ---- */
  document.querySelectorAll("[data-featured-product]").forEach(function (wrapper) {
    var jsonEl = wrapper.querySelector("[data-product-json]");
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = wrapper.querySelector("form");
    var variantInput = wrapper.querySelector("[data-variant-id-input]");
    var priceEl = wrapper.querySelector("[data-product-price]");
    var addBtn = wrapper.querySelector("[data-add-to-cart]");
    var addLabel = wrapper.querySelector("[data-add-to-cart-label]");
    // Captured once, from whatever the Liquid template actually rendered --
    // this handler is shared between main-product.liquid (real PDP, adds to
    // the cart drawer, labeled "Add to Bag") and featured-product.liquid
    // (Home page quick-buy block, labeled "Buy Now"). It used to hardcode
    // "Buy Now" here regardless of which one rendered it, silently
    // relabeling the real PDP's button on the very first variant sync.
    var addLabelAvailableText = addLabel ? addLabel.textContent.trim() : "Add to Bag";
    var qtyInput = wrapper.querySelector("[data-qty-input]");
    var qtyValue = wrapper.querySelector("[data-qty-value]");
    var mainImage = wrapper.querySelector("[data-gallery-main]");
    var notifyWrap = wrapper.querySelector("[data-notify-form-wrap]");
    var notifyTagsInput = wrapper.querySelector("[data-notify-tags-input]");

    // Shopify's product JSON stores each variant's option values as
    // option1 / option2 / option3, not as an array — map by position.
    var selected = {};
    product.options.forEach(function (name, i) {
      var activeBtn = wrapper.querySelector('[data-option-index="' + i + '"].is-active');
      var key = "option" + (i + 1);
      selected[i] = activeBtn ? activeBtn.getAttribute("data-value") : product.variants[0][key];
    });

    function findVariant() {
      return product.variants.find(function (v) {
        return Object.keys(selected).every(function (i) {
          var key = "option" + (parseInt(i, 10) + 1);
          return v[key] === selected[i];
        });
      });
    }

    // Per-variant stock counts. Emitted as a separate JSON block because
    // Shopify's `product | json` omits inventory_quantity entirely. A null
    // value means inventory isn't tracked for that variant -- NOT that it's
    // zero -- and must never produce a scarcity message.
    var inventory = {};
    var invEl = wrapper.querySelector("[data-inventory-json]");
    if (invEl) {
      try { inventory = JSON.parse(invEl.textContent); } catch (e) { inventory = {}; }
    }
    var lowStockEl = wrapper.querySelector("[data-low-stock]");
    var lowStockThreshold = parseInt(wrapper.getAttribute("data-low-stock-threshold"), 10);
    if (!lowStockThreshold || lowStockThreshold < 1) lowStockThreshold = 5;

    /* Availability is a function of the WHOLE selection, not of one value in
       isolation. The Liquid pass can only ask "does any variant with this
       value exist in stock?", which on a Color + Size product wrongly marks
       a size available because it's in stock in some other color. Here we
       hold every OTHER selected option fixed and ask whether this specific
       combination is purchasable -- so switching color re-grays the sizes
       that color doesn't have. */
    function refreshOptionAvailability() {
      wrapper.querySelectorAll("[data-option-value]").forEach(function (btn) {
        var index = parseInt(btn.getAttribute("data-option-index"), 10);
        var value = btn.getAttribute("data-value");

        var reachable = product.variants.some(function (v) {
          if (v["option" + (index + 1)] !== value) return false;
          return Object.keys(selected).every(function (i) {
            var oi = parseInt(i, 10);
            if (oi === index) return true; // the value under test
            return v["option" + (oi + 1)] === selected[i];
          });
        });

        var purchasable = product.variants.some(function (v) {
          if (v["option" + (index + 1)] !== value) return false;
          if (!v.available) return false;
          return Object.keys(selected).every(function (i) {
            var oi = parseInt(i, 10);
            if (oi === index) return true;
            return v["option" + (oi + 1)] === selected[i];
          });
        });

        var dead = !purchasable;
        // Never disable the value that's currently selected -- a disabled
        // button can't be clicked back off, which would trap the shopper on
        // a dead combination with no way to change it.
        var isSelected = selected[index] === value;
        var isColor = btn.classList.contains("option-swatch--color");

        /* Rescue path. A size can be dead in the CURRENT color and alive in
           another one -- L sold out in Black but in stock in White. Killing
           the button outright hides a sale we could still make, so instead
           we look for any in-stock variant carrying this value, remember
           which other options it needs, and leave the button live. Clicking
           it switches those other options too (and the gallery follows,
           because updateUI already swaps the image for the new variant).

           Only applies to values dead in this combination but alive in
           another. A size that is sold out in EVERY color has nowhere to
           send anyone, so it stays struck through and disabled. */
        var rescue = null;
        if (dead && !isSelected) {
          var alt = product.variants.find(function (v) {
            return v.available && v["option" + (index + 1)] === value;
          });
          if (alt) {
            rescue = {};
            product.options.forEach(function (name, oi) {
              if (oi !== index) rescue[oi] = alt["option" + (oi + 1)];
            });
          }
        }

        if (rescue) {
          btn.dataset.rescue = JSON.stringify(rescue);
          btn.classList.remove(isColor ? "is-soon" : "is-sold-out");
          btn.classList.add("is-elsewhere");
          btn.disabled = false;
          btn.removeAttribute("aria-disabled");
          var where = Object.keys(rescue).map(function (oi) { return rescue[oi]; }).join(" / ");
          btn.setAttribute("title", value + " — available in " + where);
        } else {
          delete btn.dataset.rescue;
          btn.classList.remove("is-elsewhere");
          btn.classList.toggle(isColor ? "is-soon" : "is-sold-out", dead && !isSelected);
          btn.disabled = dead && !isSelected;
          if (dead) {
            btn.setAttribute("aria-disabled", "true");
            btn.setAttribute("title", value + (reachable ? " — sold out" : " — unavailable"));
          } else {
            btn.removeAttribute("aria-disabled");
            btn.setAttribute("title", value);
          }
        }
      });
    }

    function updateLowStock(variant) {
      if (!lowStockEl) return;
      var qty = inventory[variant.id];
      // null/undefined => untracked. Zero or less => it's sold out, and the
      // Add to Bag button plus the notify form already say so; repeating it
      // here would just be noise.
      if (qty === null || typeof qty === "undefined" || !variant.available || qty <= 0 || qty > lowStockThreshold) {
        lowStockEl.hidden = true;
        lowStockEl.textContent = "";
        return;
      }
      /* Name the variant. "Only 3 left" sitting under a row of six size
         buttons is ambiguous at a glance -- it reads as a statement about
         the product, and the shopper has to infer it means the selected
         size. Saying "Only 3 left in M" removes the inference entirely.
         Skipped for single-variant products, where "Default Title" would be
         noise and there's nothing to disambiguate anyway. */
      var label = variant.title && variant.title !== "Default Title" ? variant.title : "";
      var stem = qty === 1 ? "Only 1 left" : "Only " + qty + " left";
      lowStockEl.textContent = label ? stem + " in " + label : stem;
      lowStockEl.hidden = false;
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = "$" + (variant.price / 100).toFixed(2);
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? addLabelAvailableText : "Sold Out";

      // "Notify me when back in stock" -- shown only while the currently
      // selected variant is unavailable, same trigger the Add to Bag
      // button already uses. The tags input is re-slugged with this
      // specific variant's title (not just the product) so a merchant
      // scanning back-in-stock-tagged customers can see exactly which
      // size/color someone wants, not just which product.
      if (notifyWrap) {
        notifyWrap.hidden = variant.available;
        if (notifyTagsInput) {
          var baseTags = "back-in-stock,restock-" + (product.handle || "");
          if (variant.title && variant.title !== "Default Title") {
            var variantSlug = variant.title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
            baseTags += ",variant-" + variantSlug;
          }
          notifyTagsInput.value = baseTags;
        }
      }

      updateLowStock(variant);
      refreshOptionAvailability();
    }

    wrapper.querySelectorAll("[data-option-value]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var index = btn.getAttribute("data-option-index");
        var value = btn.getAttribute("data-value");
        selected[index] = value;

        /* If this value is only purchasable under a different color/option
           set, adopt that set too rather than landing the shopper on a
           sold-out combination they'd have to fix themselves. Written before
           the is-active sweep below so those buttons repaint in the same
           pass. */
        if (btn.dataset.rescue) {
          try {
            var rescue = JSON.parse(btn.dataset.rescue);
            Object.keys(rescue).forEach(function (oi) {
              selected[oi] = rescue[oi];
              wrapper
                .querySelectorAll('[data-option-index="' + oi + '"][data-option-value]')
                .forEach(function (b) {
                  b.classList.toggle("is-active", b.getAttribute("data-value") === rescue[oi]);
                });
            });
          } catch (e) {}
        }
        // Matched by [data-option-value] rather than a specific class name
        // so this clears active state correctly for both swatch types --
        // the rectangular .option-swatch buttons (Size etc.) and the
        // circular .option-swatch--color buttons used for a Color option.
        wrapper
          .querySelectorAll('[data-option-index="' + index + '"][data-option-value]')
          .forEach(function (b) { b.classList.remove("is-active"); });
        btn.classList.add("is-active");
        updateUI();
      });
    });

    var decreaseBtn = wrapper.querySelector("[data-qty-decrease]");
    var increaseBtn = wrapper.querySelector("[data-qty-increase]");
    if (decreaseBtn) {
      decreaseBtn.addEventListener("click", function () {
        var v = Math.max(1, parseInt(qtyValue.textContent, 10) - 1);
        qtyValue.textContent = v;
        qtyInput.value = v;
      });
    }
    if (increaseBtn) {
      increaseBtn.addEventListener("click", function () {
        var v = parseInt(qtyValue.textContent, 10) + 1;
        qtyValue.textContent = v;
        qtyInput.value = v;
      });
    }

    /* Gallery thumbs preview on HOVER, not click: mousing onto a thumb
       swaps the main image and highlights that thumb; leaving it reverts
       straight back to the first/default image and the first thumb's
       highlighted state, so the gallery always resets to its starting
       point rather than getting stuck on the last-hovered image. */
    var galleryThumbs = wrapper.querySelectorAll("[data-gallery-thumb]");
    var defaultMainSrc = mainImage ? mainImage.getAttribute("src") : null;
    var defaultThumb = wrapper.querySelector("[data-gallery-thumb].is-active") || galleryThumbs[0];

    function setActiveThumb(target) {
      galleryThumbs.forEach(function (t) { t.classList.remove("is-active"); });
      if (target) target.classList.add("is-active");
    }

    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener("mouseenter", function () {
        if (mainImage) mainImage.src = thumb.getAttribute("data-full-src");
        setActiveThumb(thumb);
      });
      thumb.addEventListener("mouseleave", function () {
        if (mainImage && defaultMainSrc) mainImage.src = defaultMainSrc;
        setActiveThumb(defaultThumb);
      });
      // Keyboard users (no hover available) still get click-to-preview,
      // but it follows the same revert-on-focus-out behavior as hover.
      thumb.addEventListener("focus", function () {
        if (mainImage) mainImage.src = thumb.getAttribute("data-full-src");
        setActiveThumb(thumb);
      });
      thumb.addEventListener("blur", function () {
        if (mainImage && defaultMainSrc) mainImage.src = defaultMainSrc;
        setActiveThumb(defaultThumb);
      });
    });

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (addBtn) addBtn.disabled = true;
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: variantInput.value, quantity: parseInt(qtyInput.value, 10) || 1 }),
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            openDrawer();
          })
          .catch(function (err) { console.error("Add to cart failed:", err); })
          .finally(function () {
            updateUI();
          });
      });
    }

    updateUI();
  });

  /* Gap-closer add. Stays in the drawer on purpose -- the shopper is mid
     decision about the threshold, so bouncing them to a product page would
     lose the thread. Re-renders the cart, which re-runs the bar and either
     clears the gap or shrinks it. */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-gap-add]");
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute("data-gap-add");
    if (!id || btn.disabled) return;
    btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .catch(function (err) { console.error("Gap closer add failed:", err); })
      .finally(function () { btn.disabled = false; });
  });

  /* ---- Quick-add from product cards (collection grid / custom product grid) ---- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-quick-add]");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (btn.getAttribute("data-has-options") === "true") {
      var card = btn.closest("[data-product-card]");
      if (card) window.location.href = card.getAttribute("href");
      return;
    }

    var variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;
    var label = btn.querySelector("[data-quick-add-label]");
    var originalText = label ? label.textContent : "";
    if (label) label.textContent = "...";
    btn.disabled = true;

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (r) { return r.json(); })
      .then(function () { openDrawer(); })
      .catch(function (err) { console.error("Quick add failed:", err); })
      .finally(function () {
        btn.disabled = false;
        if (label) label.textContent = originalText;
      });
  });

  /* ---- Full cart page: remove-row shortcut (sets qty to 0 and submits) ---- */
  document.querySelectorAll("[data-cart-remove-row]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = btn.getAttribute("data-key");
      var form = btn.closest("form");
      if (!form) return;
      var input = form.querySelector('input[name="updates[' + key + ']"]');
      if (input) input.value = 0;
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  /* Sync cart count on page load */
  fetchCart();
})();
